const globalStyles = {
    global: {

    },
}
export default globalStyles;